import { defineComponent as $, useCssVars as w, computed as i } from "vue";
import { getImageBreakpoints as I } from "./component-library255.js";
import { getConfig as L } from "./component-library2.js";
import { addCdnHost as x } from "./component-library254.js";
const U = /* @__PURE__ */ $({
  __name: "picture-element",
  props: {
    src: { default: void 0 },
    srcSm: { default: void 0 },
    srcMd: { default: void 0 },
    srcLg: { default: void 0 },
    srcXl: { default: void 0 },
    height: { default: void 0 },
    width: { default: void 0 },
    aspectRatio: { default: void 0 },
    aspectRatioSm: { default: void 0 },
    aspectRatioMd: { default: void 0 },
    aspectRatioLg: { default: void 0 },
    aspectRatioXl: { default: void 0 },
    imageClass: { default: void 0 },
    imageStyle: { default: void 0 },
    alt: { default: "" },
    lazy: { type: Boolean },
    format: { default: "webp" },
    doNotConvert: { type: Boolean },
    sizes: { default: "" },
    preload: { type: Boolean }
  },
  emits: ["image-error"],
  setup(M, { expose: X }) {
    const t = M;
    w((a, e) => ({
      "36fa38b4": e.aspectRatio,
      "614ec6c0": e.aspectRatioSm,
      "614ec846": e.aspectRatioMd,
      "614ec87e": e.aspectRatioLg,
      "614ec58c": e.aspectRatioXl
    }));
    const u = i(() => t.aspectRatio), p = i(() => t.srcSm && t.aspectRatioSm ? t.aspectRatioSm : u.value), f = i(() => t.srcMd && t.aspectRatioMd ? t.aspectRatioMd : p.value), m = i(() => t.srcLg && t.aspectRatioLg ? t.aspectRatioLg : f.value), k = i(() => t.srcXl && t.aspectRatioXl ? t.aspectRatioXl : m.value), r = i(() => I(t.sizes, {
      xs: t.src || void 0,
      sm: t.srcSm || void 0,
      md: t.srcMd || void 0,
      lg: t.srcLg || void 0,
      xl: t.srcXl || void 0
    })), v = (a) => {
      const e = r.value.findIndex((o) => o.name === a);
      for (let o = e; o >= 0; o -= 1)
        if (r.value[o].src) return r.value[o].src || void 0;
    }, c = i(() => {
      const { imageOptimizer: a } = L() || {};
      return r.value ? r.value.map(({ src: e, minWidth: o, name: d, defaultWidth: C, imageWidth: S }) => {
        const s = S || C || void 0;
        if (!e && (!s || !S)) return null;
        if (e && /\.svg/i.test(e))
          return {
            name: d,
            src: x(e),
            type: "image/svg"
          };
        if (!e && (e = v(d), !e))
          return null;
        const z = {
          sizes: `${d}:${s}`,
          modifiers: {
            format: t.format
          }
        }, W = t.doNotConvert || !a ? e : a(e, z).src, h = String(s).endsWith("vw");
        let l = s;
        if (!h && /^\d+$/.test(String(s)) && (l = `${s}px`), !h && !String(l).endsWith("px"))
          return null;
        const B = parseInt(String(l), 10);
        return B ? {
          name: d,
          width: B,
          minWidth: o,
          media: (o || 0) > 0 ? `(min-width: ${o}px)` : "",
          src: x(W),
          type: `image/${t.format}`
        } : null;
      }).filter(Boolean) : [];
    }), n = i(() => c.value?.[0]), y = i(() => [...c.value].filter((a) => a && (a.minWidth || 0) > 0).sort((a, e) => (e.minWidth || 0) - (a.minWidth || 0))), g = (a) => {
    }, R = L()?.useHead || g;
    return R(() => !t.preload || !n.value?.src ? {} : {
      link: [
        {
          rel: "preload",
          as: "image",
          href: n.value.src || ""
        }
      ]
    }), X({
      defaultImage: n
    }), { __sfc: !0, props: t, aspectRatio: u, aspectRatioSm: p, aspectRatioMd: f, aspectRatioLg: m, aspectRatioXl: k, imagesBreakpoints: r, getLastSource: v, sourcesByBreakpoint: c, defaultImage: n, sourcesWithBreakpointReverse: y, mockUseHead: g, useHead: R };
  }
});
export {
  U as default
};
